/**
 * Gets ENV value
 * Note: Parses to boolean in case of 'true' or 'false
 * @param {String} confName 
 * @returns {*}
 */
export function env(confName = ''){
  confName = 'VUE_' + confName;
  if(process.env[confName] === undefined)
      return null;
  let value = process.env[confName];
  switch (process.env[confName]) {
    case 'true':
      value = true;
      break;
    case 'false':
      value = false;
      break;
  }
  return value;
}